module.exports = __webpack_public_path__ + "static/media/MenuItemsCostPricing.6fcc62e3.svg";